import config from '@config'

export const groupStackExportMembers = async (groupId, groupName, sid, locale) =>
    fetch(`${config.api.groupStack.exportGroup.uri}?group_id=${groupId}&group_name=${groupName}&lang=${locale}`, {
        method: config.api.groupStack.exportGroup.method,
        mode: 'cors',
        headers: {
            sid,
            Accept: 'text/plain',
            'Content-Disposition': 'attachment',
            'Content-Type': 'application/vnd.ms-excel',
        },
    })
        .then((resp) => resp.blob())
        .catch((err) => console.log(`Group stack export members to xls threw error: ${err}`)) // eslint-disable-line
